import { Grid } from "carbon-components-react";
import UIShell from "../components/UIShell";

export default function HomePage() {
    return (
        <UIShell>
            <Grid>
                <h1>Welcome!</h1>
            </Grid>
        </UIShell>
    )
}